<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 쿠폰 관리 START -->
    <div class="section fill">
      <div class="inner">
        <div class="box_title">
          <h2 class="mb-2">체험판 코드 등록</h2>
          <div class="input_wrap">
            <label for="cp" class="lb_wrap">
              <!-- <span class="ab_text">{{ couponCd }}</span> -->
              <input
                id="cp"
                v-model.trim="couponNo"
                type="text"
                placeholder="체험판 코드를 등록하세요"
                maxlength="19"
                @input="handleCouponInput"
              />
            </label>
          </div>
          <div>
            <a
              class="box_btn"
              :class="isValid ? '' : 'disabled'"
              @click="requestCoupon"
            >
              <span class="an_t">확인</span>
            </a>
          </div>
        </div>
        <div class="box_title">
          <h2 class="mb-2">선물 코드 등록</h2>
          <div class="input_wrap">
            <label for="cp" class="lb_wrap">
              <input
                id="cp"
                v-model.trim="giftNo"
                type="text"
                placeholder="선물 코드를 등록하세요"
                maxlength="23"
                @input="handleGiftInput"
              />
            </label>
          </div>
          <div>
            <a class="box_btn" @click="requestGift">
              <span class="an_t">확인</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="closeErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="closeErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_inner">
              <strong>
                {{ errorMessage }}
              </strong>
              <p>
                {{ subErrMsg }}
              </p>
              <div class="btnWrap">
                <button class="box_btn wt" @click="closeErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
                <button v-if="showLibaray" class="box_btn" @click="toLibrary">
                  <span class="an_t">내 서재 바로가기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AccountHead from '../../components/member/AccountHead.vue'

export default {
  name: 'Coupon',
  components: { AccountHead },
  data() {
    return {
      showErrorModal: false,
      errorMessage: false,
      subErrMsg: '',
      couponNo: '',
      showLibaray: false,
      isValid2: true,
      giftNo: ''
    }
  },
  computed: {
    isValid() {
      return this.isValid2
    },
    ...mapGetters(['getCurrentUser'])
  },
  methods: {
    async requestCoupon() {
      if (!this.isValid) {
        return
      }
      await this.$store
        .dispatch('requestCoupone', {
          memberTp: this.getCurrentUser?.memberTp,
          purchaseTp: 'CPN',
          couponNo: this.couponNo
        })
        .then((res) => {
          if (res.data.ok) {
            this.showLibaray = true
            this.errorMessage = '쿠폰 적용이 완료되었습니다.'
            this.subErrMsg = `내 서재 → 체험판 도서 책장을 확인해주세요.`
            this.toggleErrorModal()
          }
        })
        .catch((err) => {
          console.log(err.response.data.errorState.message)
          if (err.response) {
            this.showLibaray = false
            this.errorMessage = err.response.data.errorState.message
            this.subErrMsg = '쿠폰 번호 확인 후 다시 입력해주세요.'
            if (err.response.data.errorState.reason === '사용 완료') {
              this.subErrMsg = '내 서재 → 체험판 도서 책장을 확인해주세요'
              this.showLibaray = true
            }
            this.toggleErrorModal()
          }
        })
    },
    // hint
    closeErrorModal() {
      if (this.showLibaray) {
        this.$router.go()
      }
      this.showErrorModal = false
    },
    toggleErrorModal() {
      // e.preventDefault()
      this.showErrorModal = !this.showErrorModal
    },
    toLibrary() {
      this.toggleErrorModal()
      this.$router.push({
        name: 'library_default'
      })
    },
    handleCouponInput(event) {
      // first parmas: 사용자가 타입할때 들어오는 값
      // second parmas: 타입 시점의 cardNumber 전체 값
      const inputValue = event.target.value
      this.couponNo = this.couponFormatter(inputValue)
    },
    couponFormatter(inputValue) {
      // 입력값 정리
      let couponNo = inputValue.trim()

      // 허용되지 않는 문자 제거 (영문자, 숫자, 하이픈만 허용)
      couponNo = couponNo.replace(/[^A-Za-z0-9-]/g, '')

      // 하이픈으로 올바르게 포맷팅 (4자리씩 그룹화)
      // 먼저 모든 하이픈 제거
      const digitsOnly = couponNo.replace(/-/g, '')

      // 4자리씩 그룹화하여 하이픈 추가
      const formattedValue =
        digitsOnly.match(/[A-Za-z0-9]{1,4}/g)?.join('-') || digitsOnly

      return formattedValue
    },
    handleGiftInput(event) {
      const inputValue = event.target.value

      // 접두사 GFT- 만 남았을 때 backspace를 누른 경우
      if (inputValue === 'GFT') {
        this.giftNo = 'GFT-'
        return
      }

      // 일반적인 formatter 로직 적용
      this.giftNo = this.giftFormatter(inputValue)
    },
    giftFormatter(inputValue) {
      // 입력값에서 GFT- 부분을 제거
      let cleanInput = inputValue.replace(/^GFT-?/, '')

      // 허용되지 않는 문자 제거 (영문자, 숫자, 하이픈만 허용)
      cleanInput = cleanInput.replace(/[^A-Za-z0-9-]/g, '')

      // 하이픈으로 올바르게 포맷팅
      const digitsOnly = cleanInput.replace(/-/g, '')

      // 4자리씩 그룹화하여 하이픈 추가
      const formattedGroups =
        digitsOnly.length > 0
          ? digitsOnly.match(/[A-Za-z0-9]{1,4}/g)?.join('-') || digitsOnly
          : ''

      // 최종 값 앞에 "GFT-" 추가
      return 'GFT-' + formattedGroups
    },
    async requestGift() {
      if (!this.isValid) {
        return
      }
      await this.$store
        .dispatch('requestGifte', {
          purchaseTp: 'GFT',
          couponNo: this.giftNo
        })
        .then((res) => {
          if (res.data.ok) {
            this.errorMessage = '쿠폰 적용이 완료되었습니다.'
            this.subErrMsg = "내 서재'에서 등록된 도서를 확인해주세요."
            this.toggleErrorModal()
          }
        })
        .catch((err) => {
          console.log(err.response.data.errorState.message)
          if (err.response) {
            this.errorMessage = err.response.data.errorState.message
            this.subErrMsg = '쿠폰 번호 확인 후 다시 입력해주세요.'
            this.toggleErrorModal()
          }
        })
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.section.fill .inner {
  display: flex;
}
.input_wrap {
  display: flex;
  justify-content: center;
}
.lb_wrap {
  position: relative;
  width: 460px;
  height: 48px;
  input {
    // color: transparent;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    margin: 0;
    background: transparent;
    padding-left: 16px;
  }
  .ab_text {
    z-index: 98;
    padding-left: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: black;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.ly_pop_content.ly_pop_msg.ly_txt {
  width: 540px;
  height: 257px;
  text-align: center;
  .ly_inner {
    padding-top: 60px !important;
    p {
      font-size: 16px;
      color: #778899;
    }
  }
}
input {
  width: 460px;
  height: 48px;
  margin-top: 40px;
  border: 1px solid #d5dff3;
  box-sizing: border-box;
  border-radius: 12px;
}

.box_title {
  .box_btn {
    width: 100%;
    height: 56px;
    margin-top: 16px;
    background-color: #008df3;
    border-radius: 12px;
    border: none;
    .an_t {
      font-family: 'pretendard-medium';
      font-size: 18px;
      line-height: 56px;
    }
  }
}

.btnWrap {
  display: flex;
  justify-content: center;
  .box_btn {
    width: 50%;
    height: 56px;
    .an_t {
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 18px;
      line-height: 56px;
      letter-spacing: 0;
    }
  }
}
.disabled {
  background-color: #778899;
  border-color: #778899;
}
.member_st .box_title {
  display: block !important;
}
@media (max-width: 960px) {
  .section.fill .inner {
    flex-direction: column;
  }
  .box_title .box_btn {
    width: 460px;
  }
}
@media (max-width: 768px) {
  .ly_pop_content.ly_pop_msg.ly_txt {
    .ly_inner {
      p {
        word-break: keep-all;
      }
    }
  }
}
@media screen and (max-width: 520px) {
  input {
    width: 100%;
  }

  .box_title {
    .box_btn {
      width: 100%;
    }
  }
}
</style>
